import { checkInConstants } from '../constants/checkInConstants';

const initialState = {
    checkIn: {},
    identifiedCheckIn: {
        loading: false,
        valid: false,
        data: null,
        error: null
    }, 
    error : null
};

const checkInReducer = (state = initialState, action) => {
    switch (action.type) {
        case checkInConstants.CREATE_SUCCESS :
            return {
                ...state,
                checkIn : action.data,
                error : null
            }
        case checkInConstants.REFRESH_STATUS_SUCCESS :
            return {
                ...state,
                checkIn : { ...state.checkIn, status : action.status, evolutions : action.evolutions },
                error : null
            }
        case checkInConstants.REFRESH_SUBSCRIPTIONS:
            return {
                ...state,
                checkIn : { ...state.checkIn, subscriptions : action.subscriptions },
                error : null
            }
        case checkInConstants.IDENTIFY_REQUEST:
            return {
                ...state,
                identifiedCheckIn : {
                    loading: true,
                    valid: false,
                    data: null,
                    error: null
                }
            }
        case checkInConstants.IDENTIFY_SUCCESS: 
            return {
                ...state,
                identifiedCheckIn : {
                    loading: false,
                    valid: false,
                    data: action.checkIn,
                    error: null
                }
            }
        case checkInConstants.IDENTIFY_VALIDATED: 
            return {
                ...state,
                checkIn: { ...action.checkIn },
                identifiedCheckIn : {
                    loading: false,
                    valid: true,
                    data: action.checkIn,
                    error: null
                }
            }
        case checkInConstants.IDENTIFY_RETRY: 
            return {
                ...state,
                identifiedCheckIn : {
                    loading: false,
                    valid: false,
                    data: { ...state.identifiedCheckIn.data },
                    error: null
                }
            }
        case checkInConstants.IDENTIFY_FAILURE: 
            return {
                ...state,
                identifiedCheckIn : {
                    loading: false,
                    valid: false,
                    data: null,
                    error: action.error
                }
            }
        case checkInConstants.NOTIFICATION : 
            console.log('ID APP', state.checkIn.id)
            console.log('ID ACTION', action.data.id)
            alert('UPDATE CHECKIN')
            if (state.checkIn.id == action.data.id) {
                return {
                    ...state,
                    checkIn : { ...state.checkIn, ...action.data }
                }
            }
            console.log('notif id', action.data.id)
        case checkInConstants.RESET : 
            return {
                ...state,
                checkIn : { passengers : [], evolutions: [], status: null },
                identifiedCheckIn: { loading: false, valid: false, data: null, error: null }
            }
        default:
            return state
    }
}

export default checkInReducer